import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentCardComponent } from './document-card.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
@NgModule({
  declarations: [
    DocumentCardComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    SharedModule,
    IconsModule
  ],
  exports: [
    DocumentCardComponent
  ]
})
export class DocumentCardModule { }
